var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":6}},[_c('left-table')],1),_c('el-col',{attrs:{"span":18}},[_c('right-table')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }